import angular from 'angular';

angular.module('cloudX').directive('cxSortHeader', [
  function() {
    return {
      restrict: 'A',
      replace: 'true',
      template:
        '<th class="clickable" ng-click="sort(canSort(true))">' +
        '<span>{{key | translate}}</span>' +
        '<i class="glyphicon margin10L" ng-show="vm.sortBy==name" ng-class="canSort(true)?\'glyphicon-triangle-bottom\':\'glyphicon-triangle-top\'"></i>' +
        //'<button class="inverse"  ng-show="canSort(false)" ng-class="{\'subtle\':vm.sortBy==\'{{name}}\'}"><i class="glyphicon glyphicon-menu-down"></i></button>' +
        //'<button class="inverse" ng-click="sort(true)" ng-show="canSort(true)" ng-class="{\'subtle\':vm.sortBy==\'{{name}}\'}"><i class="glyphicon glyphicon-menu-up"></i></button>' +
        '</th>',
      scope: true, //Gives the directive a nested, but not isolated scope.
      link: function(scope, element, attrs) {
        scope.key = attrs.key;
        scope.name = attrs.name;
      },
      //$filter('translate')('To');
      controller: [
        '$scope',
        function($scope) {
          $scope.canSort = function(dir) {
            if ($scope.vm.canSort) {
              return $scope.vm.canSort($scope.name, dir);
            } else {
              console.warn('The function "can sort" is not defined.');
            }
          };

          $scope.sort = function(dir) {
            if ($scope.vm.sort) {
              $scope.vm.sort($scope.name, dir);
            } else {
              console.warn('The function "sort" is not defined.');
            }
          };
        },
      ],
    };
  },
]);
